module.exports = __webpack_public_path__ + "img/login-car-v2-Abrare.a3657af0.svg";